<template>
  <full-container>
    <div slot="header" class="toolbar">
      <el-form inline size="small">
        <el-form-item>
          <el-radio-group v-model="queryParams.state" @change="onSearch()">
            <el-radio-button>全部</el-radio-button>
            <el-radio-button :label="true">发货完成</el-radio-button>
            <el-radio-button :label="false">等待发货</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-input v-model="queryParams.keyWord" clearable placeholder="订单号/客户/商品" style="width: 300pxx">
            <template slot="append">
              <el-button icon="el-icon-search" @click="onSearch()" />
            </template>
          </el-input>
        </el-form-item>
      </el-form>
      <el-button-group>
        <el-button v-action="'/api/Mall/Parcel/Download'" icon="el-icon-download" size="small" @click="onDownload" />
        <template v-action="'/api/Mall/Parcel/Submit'">
          <el-button size="small" type="primary" @click="expand = !expand">{{
            expand ? `选中${selection.length}件` : "批量发货"
          }}</el-button>
          <el-button v-if="expand" type="danger" size="small" @click="drawer = !drawer">确定发货</el-button>
        </template>
      </el-button-group>
    </div>
    <!--表格-->
    <el-table v-loading="loading" :data="datalist.Items" height="100%">
      <el-table-column prop="Order.Code" label="订单编号" width="100" show-overflow-tooltip />
      <el-table-column prop="Customer" label="客户名称" min-width="200" show-overflow-tooltip />
      <el-table-column prop="Goods.Code" label="库存编码" min-width="140">
        <template slot-scope="{ row }">
          {{ $utils.meta.format("branch", row.Goods.Stock) }}
          {{ row.Goods.Code }}
        </template>
      </el-table-column>
      <el-table-column prop="Goods.Name" label="品名及规格" min-width="200" show-overflow-tooltip />
      <el-table-column label="已发/订购" min-width="120">
        <template slot-scope="{ row }">
          <label>{{ row.Parcels }}/{{ row.Amount }}{{ row.Goods.Unit }}</label>
          <el-tag size="mini" type="danger" effect="plain" style="margin-left: 5px" v-if="row.Amount != row.Parcels">差{{
            row.Amount - row.Parcels }}{{ row.Goods.Unit }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="单价" min-width="80">
        <template slot-scope="{ row }">
          <label class="text-price">{{ row.Price }}</label>
        </template>
      </el-table-column>
      <el-table-column label="下单时间" width="140">
        <template slot-scope="{ row }">
          {{
            $utils.common.parseTime(row.Order.CreateTime, "{y}-{m}-{d} {h}:{i}")
          }}
        </template>
      </el-table-column>
      <el-table-column label="负责人" width="120" show-overflow-tooltip>
        <template slot-scope="{ row }">
          {{ row.Dept }}
          {{ row.User }}
        </template>
      </el-table-column>
      <el-table-column v-if="expand" align="center" width="60">
        <template slot="header">
          <el-link :underline="false" type="danger" icon="el-icon-remove" @click="selection = []" />
        </template>
        <template slot-scope="{ row }">
          <el-link v-if="row.Amount != row.Parcels" :underline="false" :type="Exists(row) ? 'info' : 'primary'"
            icon="el-icon-circle-plus" @click="onSelect(row)" />
        </template>
      </el-table-column>
    </el-table>

    <!--分页-->
    <el-pagination slot="footer" background :page-size="queryParams.size" :total="datalist.TotalCount"
      @current-change="onSearch" />

    <!--抽屉-->
    <el-drawer v-if="expand" v-action="'/api/Mall/Parcel/Submit'" title="确定发货：请核对发货单信息..." :visible.sync="drawer"
      size="50%">
      <batchForm :goods.sync="selection" v-if="drawer" />
    </el-drawer>
  </full-container>
</template>

<script>
export default {
  components: {
    batchForm: () => import("./_parcels.vue"),
  },
  data() {
    return {
      timer: null,
      loading: false,
      datalist: {},
      queryParams: {
        index: 1,
        size: 20,
      },
      selection: [],
      expand: false,
      drawer: false,
    };
  },
  computed: {
    Exists() {
      return (row) => {
        return this.selection.findIndex((x) => x.Id == row.Id) == -1;
      };
    },
  },
  destroyed() {
    //离开页面是销毁轮询
    clearInterval(this.timer);
  },
  created() {
    //默认执行一次
    this.loadData();
    // 实现轮询
    this.timer = window.setInterval(() => {
      setTimeout(this.loadData(), 0);
    }, 1000 * 60 * 2);
  },
  methods: {
    // 查询参数
    onSearch(val = 1) {
      this.queryParams.index = val;
      this.loadData();
    },
    // 信息列表
    loadData() {
      this.loading = true;
      this.$apis.mall.order.item
        .list(this.queryParams)
        .then((res) => {
          this.datalist = res;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 下载数据
    onDownload() {
      this.$confirm(
        "此操作将根据当前条件下载数据到Execl中,数据过多时需要花费一定时间才能完成操作，是否继续？",
        `下载数据（xls）`,
        {
          center: true,
          type: "warning",
        }
      ).then(() => {
        //开始下载
        this.loading = true;
        this.$apis.mall.order.item.download(this.queryParams)
          .then((res) => {
            this.$message({ message: res, type: "success" });
          })
          .catch((e) => {
            this.$message.error(e || "操作失败");
          })
          .finally(() => {
            this.loading = false;
          });
      });
    },

    //选择商品
    onSelect(row) {
      let index = this.selection.findIndex((x) => x.Id == row.Id);
      if (index == -1) {
        this.selection.push(row);
      } else {
        this.selection.splice(index, 1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-link {
  font-size: 20px !important;
}
</style>
